const importTypes = {
  update: 'update',
  override: 'override',
};

export { importTypes };
